import { render, staticRenderFns } from "./ImportProperties.vue?vue&type=template&id=70268bad"
import script from "./ImportProperties.vue?vue&type=script&lang=js"
export * from "./ImportProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports